import { clsx } from "clsx";
import type { ReactNode } from "react";
import styles from "./FullScreenCardPage.module.css";

type FullScreenCardPageProps = {
  className?: string;
  children?: ReactNode;
};

export default function FullScreenCardPage({ className, children }: FullScreenCardPageProps) {
  return (
    <div className={styles.backdrop}>
      <div className={clsx(styles.card, className)}>{children}</div>
    </div>
  );
}
